module.exports = __webpack_public_path__ + "static/media/about.a2221788.svg";